import React, { useEffect } from "react";
import Container from "../../components/FormContainer/FormContainer.js";
import Section from "../../components/FormSection/FormSection.js";
import { useNavigate } from "react-router-dom";

export default function Form() {
    const navigate = useNavigate();

    useEffect(() => {
        if (sessionStorage.getItem("started")) {
            navigate("/initial-form");
            return
        }
    }, []);

    const handleStart = () => {
        sessionStorage.setItem("started", "true");
        window.location.reload();
    }

    return (
        <Container>
            <p className={"justify-center"} style={{
                fontSize: "1.8rem", color: "var(--accent-color)", fontWeight: "500"
            }}>Welcome to the Good Spirit School Division Registration Form!</p>
            <hr />
            <Section title={"Things you should know:"}>
                <ul>
                    <li>For the best result, use <b>Google Chrome</b> or <b>Microsoft Edge.</b></li>
                    <li>Red asterisks (<span style={{ color: "red" }}>*</span>) indicate mandatory fields.</li>
                </ul>
            </Section>
            <hr />
            <button type="button" onClick={handleStart} className={"default-btn justify-center"}>
                Get Started!
            </button>
        </Container>
    )
}